<template>
  <div>
    <div class="bar" id="barId"></div>
    <div class="top">
      <div class="topText1">吉林一号在线地图访问</div>
      <div class="topText2">
        提供在线浏览与API调用双场景服务，您可在吉林一号网实验室平台交互式浏览高清影像，<br />亦可直接获取API接口，轻松集成至您的业务系统与应用中。
      </div>
      <div class="topBtn1" @click="jumpWithPermission('仅登录','/lab','/rskit')">立即浏览</div>
      <div class="topBtn2" @click="$router.push('/rsManage')">前往调用</div>
      <div class="topBtn2" style="left: calc(50% + 116px);" @click="$router.push('/onlineService/Home')">购买咨询</div>
    </div>
    <div class="content1">
      <div class="ctn1Text1"><span style="color: #1890FF;">国际领先</span>的高分辨率卫星影像</div>
      <div class="ctn1">
        <div class="ctn1Title">
          <div :class="titleSel==1?'ctn1Title1':'ctn1Title1-s'" @click="titleSel=1">优质影像质量</div>
          <div :class="titleSel==2?'ctn1Title1':'ctn1Title1-s'" @click="titleSel=2">广域高频更新</div>
          <div :class="titleSel==3?'ctn1Title1':'ctn1Title1-s'" @click="titleSel=3">丰富历史回溯</div>
          <div :class="titleSel==4?'ctn1Title1':'ctn1Title1-s'" @click="titleSel=4">安全合规保障</div>
          <div :class="titleSel==5?'ctn1Title1':'ctn1Title1-s'" @click="titleSel=5">便捷集成调用</div>
        </div>
        <span v-if="titleSel==1">
          <div class="ctn1Text2">提供国际领先的高分辨率卫星影像，确保细节清晰、定位精准</div>
          <div class="ctn1Text3">最高提供0.5米分辨率影像，能清晰辨识地表精细特征</div>
          <div class="ctn1Text3" style="top: 193px;">依托智能筛选与处理技术，保障影像的高清画质和几何精度</div>
          <div class="ctn1Text3" style="top: 231px;">在线地图支持高达18级缩放，满足从宏观区域到微观目标的观察需求</div>
          <img src="../assets/Home/图1.png" alt="" style="position: absolute;right: 0;">
        </span>
        <span v-if="titleSel==2">
          <div class="ctn1Text2">卫星影像大范围、高频更新，解决数据陈旧和覆盖不全难题</div>
          <div class="ctn1Text3">“全国一张图”提供每季度稳定更新，确保信息的时效性</div>
          <div class="ctn1Text3" style="top: 193px;">全国单期有效覆盖率不低于90%，影像数据年度更新，保持图源现势性</div>
          <div class="ctn1Text3" style="top: 231px;">由超过百颗卫星组成的星座支持，具备高频重访能力，更新速度快</div>
          <img src="../assets/Home/图2.png" alt="" style="position: absolute;right: 0;width: 472px;">
        </span>
        <span v-if="titleSel==3">
          <div class="ctn1Text2">持续累积的多年份历史影像库，为变化检测分析提供数据底座</div>
          <div class="ctn1Text3">提供2020至2026年的全国高分辨率卫星影像序列</div>
          <div class="ctn1Text3" style="top: 193px;">存档包括2021至2023年的全球高分辨率卫星影像资源</div>
          <div class="ctn1Text3" style="top: 231px;">历史影像资源总面积超过5亿平方公里，支持长时序分析</div>
          <img src="../assets/Home/图3.png" alt="" style="position: absolute;right: 0;">
        </span>
        <span v-if="titleSel==4">
          <div class="ctn1Text2">所有图源经过国家权威部门审核，确保合法性与安全性</div>
          <div class="ctn1Text3">每张图源均取得自然资源部审图中心颁发的唯一审图号</div>
          <div class="ctn1Text3" style="top: 193px;">严格遵守国家政策法规，是卫星影像在互联网合规发布的“通行证”</div>
          <div class="ctn1Text3" style="top: 231px;">流程规范，让您使用无忧，规避版权与合规风险</div>
          <img src="../assets/Home/图4.png" alt="" style="position: absolute;right: 0;">
        </span>
        <span v-if="titleSel==5">
          <div class="ctn1Text2">提供简单易用的API接口，可轻松嵌入各类主流GIS平台应用</div>
          <div class="ctn1Text3">支持在ArcGIS、QGIS、超图、奥维互动地图等主流地理信息平台中在线调用</div>
          <div class="ctn1Text3" style="top: 193px;">接口设计友好，极大降低了技术集成与开发门槛</div>
          <div class="ctn1Text3" style="top: 231px;">满足多样化的业务集成需求，助力快速构建定制化地图应用</div>
          <img src="../assets/Home/图5.png" alt="" style="position: absolute;right: 0;">
        </span>
      </div>
    </div>
    <div class="content2">
      <div class="ctn1Text1"><span style="color: #1890FF;">持续更新</span>的图源体系</div>
      <div class="ctn2">
        <div class="ctn2Block1">
          <img src="../assets/Home/基础图源.png" alt="" style="position: absolute;top: 28px;left: 220px;">
          <div class="ctn2Text1">基础图源</div>
          <div class="ctn2Line1"></div>
          <div class="ctn2Text2" style="margin-top: 82px;">
            <div class="ctn2Circle"></div>
            <div class="ctn2Text3">全国年度一张图系列（2020-2024年全国高质量一张图）</div>
          </div>
          <div class="ctn2Text2">
            <div class="ctn2Circle"></div>
            <div class="ctn2Text3">全国季度一张图系列（2023-2025年6月，持续更新中）</div>
          </div>
          <div class="ctn2Text2">
            <div class="ctn2Circle"></div>
            <div class="ctn2Text3">全球一张图基础版系列（2021-2022年全球一张图）</div>
          </div>
          <!-- <div class="ctn2Text2">
            <div class="ctn2Circle"></div>
            <div class="ctn2Text3">全国半年精选图系列（已更新至2024年下半年）</div>
          </div>
          <div class="ctn2Text2">
            <div class="ctn2Circle"></div>
            <div class="ctn2Text3">全球一张图基础版系列（2020-2022年全球一张图）</div>
          </div> -->
          <div class="ctn2Btn1" @click="jumpLabWithPermission('/lab?path=0-0&type=基础图源')">立即浏览</div>
          <div class="ctn2Btn1" style="left: 300px;" @click="$router.push('/rsManage')">前往调用</div>
        </div>
        <div class="ctn2Block1" style="left: 600px;">
          <img src="../assets/Home/高级图源.png" alt="" style="position: absolute;top: 28px;left: 220px;">
          <div class="ctn2Text1">高级图源</div>
          <div class="ctn2Line1"></div>
          <div class="ctn2Text2" style="margin-top: 82px;">
            <div class="ctn2Circle"></div>
            <div class="ctn2Text3">全国季度一张图系列（已更新至2026年第三季度）</div>
            <img src="../assets/dataPack/purchaseData/新.png" alt="" style="position: absolute;left: 467px;top: 4px;">
          </div>
          <div class="ctn2Text2">
            <div class="ctn2Circle"></div>
            <div class="ctn2Text3">全球一张图高级版系列（2023年全球一张图，不定期更新）</div>
          </div>
          <!-- <div class="ctn2Text2">
            <div class="ctn2Circle"></div>
            <div class="ctn2Text3">全国半年精选图系列（已更新至2025年下半年）</div>
            <img src="../assets/dataPack/purchaseData/新.png" alt="" style="position: absolute;left: 451px;top: 4px;">
          </div>
          <div class="ctn2Text2">
            <div class="ctn2Circle"></div>
            <div class="ctn2Text3">全球一张图高级版系列（2023年全球一张图，不定期更新）</div>
          </div> -->
          <div class="ctn2Btn1" style="background: #722ED1;" @click="jumpLabWithPermission('/lab?path=0-0&type=高级图源')">立即浏览</div>
          <div class="ctn2Btn1" style="left: 300px;background: #722ED1;" @click="$router.push('/rsManage')">前往调用</div>
        </div>
        <div class="ctn2Block2">
          <div class="ctn2Text4">2026年图源更新计划</div>
          <div class="ctn2Text5" @click="openSourceUpdateModal">图源更新说明</div>
          <img src="../assets/Home/更新计划.png" alt="" style="position: absolute;top: 76px;left: 48px;width: 1080px;">
        </div>
      </div>
    </div>
    <div class="content3">
      <div class="ctn1Text1"><span style="color: #1890FF;">各行各业</span>都在用的解决方案</div>
      <div class="carousel-container" @mouseenter="pauseAutoScroll" @mouseleave="startAutoScroll">
        <!-- 滚动轨道 -->
        <div class="carousel-track" ref="trackRef" :style="trackStyle">
          <div v-for="(item, index) in displayItems" :key="index+'displayItems'" class="carousel-item" :style="getItemStyle(index)">
            <div class="content3Card" @mouseenter="item.showImg=false" @mouseleave="item.showImg=true">
              <img src="../assets/Home/轮播1.png" :alt="item.title" class="cardImg" v-if="index%8==0&&item.showImg">
              <img src="../assets/Home/轮播2.png" :alt="item.title" class="cardImg" v-if="index%8==1&&item.showImg">
              <img src="../assets/Home/轮播3.png" :alt="item.title" class="cardImg" v-if="index%8==2&&item.showImg">
              <img src="../assets/Home/轮播4.png" :alt="item.title" class="cardImg" v-if="index%8==3&&item.showImg">
              <img src="../assets/Home/轮播5.png" :alt="item.title" class="cardImg" v-if="index%8==4&&item.showImg">
              <img src="../assets/Home/轮播6.png" :alt="item.title" class="cardImg" v-if="index%8==5&&item.showImg">
              <img src="../assets/Home/轮播7.png" :alt="item.title" class="cardImg" v-if="index%8==6&&item.showImg">
              <img src="../assets/Home/轮播8.png" :alt="item.title" class="cardImg" v-if="index%8==7&&item.showImg">
              <div :class="item.showImg?'card3Title':'card3Title-s'">{{ item.title }}</div>
              <div :style="item.showImg?'margin-top:260px':'margin-top:72px'"></div>
              <span v-for="(para, idx) in item.paragraph" :key="idx">
                <div class="cardText1" :style="item.showImg?'margin-bottom:16px':'margin-bottom:4px'">
                  <div class="cardCircle"></div><span class="cardText2">{{ para.title }}</span>
                </div>
                <div class="cardText3" v-if="!item.showImg">{{ para.content }}</div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content4">
      <div class="ctn1Text1">为您推荐<span style="color: #1890FF;">选购方案</span></div>
      <div class="ctn4Text1">高清影像的浏览与API调用均会消耗流量，我们提供通用流量与图源包年两种选购方案，助您无忧探索地球奥秘。</div>
      <div class="ctn4Block1">
        <img src="../assets/Home/通用流量.png" alt="" style="position: absolute;top: 28px;left: 220px;">
        <div class="ctn4Text2">通用流量</div>
        <div class="ctn4Text3">按需使用，随用随充，适合根据需求灵活使用图源的用户</div>
        <div class="ctn4Line"></div>
        <img src="../assets/dataPack/purchaseData/对号灰.png" alt="" class="ctn4Icon1">
        <img src="../assets/dataPack/purchaseData/对号灰.png" alt="" class="ctn4Icon1" style="top: 160px;">
        <img src="../assets/dataPack/purchaseData/对号灰.png" alt="" class="ctn4Icon1" style="top: 200px;">
        <img src="../assets/dataPack/purchaseData/对号灰.png" alt="" class="ctn4Icon1" style="top: 240px;">
        <div class="ctn4Text4">购买基础/高级流量，支持浏览调用同类别下所有图源</div>
        <div class="ctn4Text4" style="top: 150px;">实名认证用户可每日领取4万次免费流量（仅用于体验图源）</div>
        <div class="ctn4Text4" style="top: 190px;"><span style="color: #1890FF;" @click="jumpWithPermission('可游客','/store/VIPBenefits','/rskit')">认证机构企业用户</span>可免费领取10万次基础流量（价值500元）</div>
        <div class="ctn4Text4" style="top: 230px;">矢量管理&影像拆分工具，聚焦关注区域</div>
        <div class="ctn4Btn1" @click="$router.push('/GeneralTraffic/Home')">了解更多</div>
        <div class="ctn4Btn1" style="left: 300px;" @click="$router.push({ path: '/GeneralTraffic/Home', hash: '#price-section' })">查看价格</div>
      </div>
      <div class="ctn4Block1" style="left: calc(50% + 12px);">
        <img src="../assets/Home/图源包年.png" alt="" style="position: absolute;top: 28px;left: 220px;">
        <div class="ctn4Text2">图源包年</div>
        <div class="ctn4Text3">指定图源，无忧使用，适合有持续、大量需求的用户</div>
        <div class="ctn4Line"></div>
        <img src="../assets/dataPack/purchaseData/对号灰.png" alt="" class="ctn4Icon1">
        <img src="../assets/dataPack/purchaseData/对号灰.png" alt="" class="ctn4Icon1" style="top: 160px;">
        <img src="../assets/dataPack/purchaseData/对号灰.png" alt="" class="ctn4Icon1" style="top: 200px;">
        <!-- <img src="../assets/dataPack/purchaseData/对号灰.png" alt="" class="ctn4Icon1" style="top: 240px;"> -->
        <div class="ctn4Text4">选择指定基础/高级图源，自选区域购买一年有效期</div>
        <div class="ctn4Text4" style="top: 150px;">每日30W次定向流量，无忧使用</div>
        <div class="ctn4Text4" style="top: 190px;">矢量管理&影像拆分工具，聚焦关注区域</div>
        <!-- <div class="ctn4Text4" style="top: 230px;">web&APP数据同步，双端浏览</div> -->
        <div class="ctn4Btn1" @click="$router.push('/AnnualPurchase/Home')">了解更多</div>
        <div class="ctn4Btn1" style="left: 300px;" @click="$router.push({ path: '/AnnualPurchase/Home', hash: '#annual-price-section' })">查看价格</div>
      </div>
    </div>
    <div
      v-if="showSourceUpdateModal"
      class="source-update-mask"
      @click.self="closeSourceUpdateModal"
    >
      <div class="source-update-dialog" role="dialog" aria-labelledby="source-update-title">
        <button
          type="button"
          class="source-update-close"
          aria-label="关闭"
          @click="closeSourceUpdateModal"
        >
          ×
        </button>
        <h2 id="source-update-title" class="source-update-dialog-title">图源更新说明</h2>
        <div class="source-update-body">
          <div class="source-update-section">
            <p class="source-update-p">1. 图源更新说明：</p>
            <p class="source-update-p">
              图源列表将根据时效性进行滚动更新，随着高级图源中的图源时效不断更新，高级图源中的部分非最新时效图源将被下放至基础图源。
            </p>
          </div>
          <div class="source-update-section">
            <p class="source-update-p">2. 图源时效说明：</p>
            <p class="source-update-p">
              高级图源：国内区域90%以上区域最新时效为2-3个月，海外区域80%以上区域最新时效为6-30个月；
            </p>
            <p class="source-update-p">
              基础图源：国内区域90%以上区域最新时效为9-18个月，海外区域80%以上区域最新时效为42-54个月。
            </p>
          </div>
          <div class="source-update-section">
            <p class="source-update-p">3. 高级图源更新计划：</p>
            <p class="source-update-p"><span class="source-update-month">2026年1月：</span>2025年第六期（11-12月）全国一张图上线高级图源。</p>
            <p class="source-update-p"><span class="source-update-month">2026年4月：</span>2026年第一季度全国一张图上线高级图源。</p>
            <p class="source-update-p"><span class="source-update-month">2026年7月：</span>2026年第二季度全国一张图上线高级图源。</p>
            <p class="source-update-p"><span class="source-update-month">2026年10月：</span>2026年第三季度全国一张图上线高级图源。</p>
            <p class="source-update-p"><span class="source-update-month">2027年1月：</span>2026年第四季度全国一张图上线高级图源。</p>
          </div>
          <div class="source-update-section">
            <p class="source-update-p">4. 基础图源更新计划：</p>
            <p class="source-update-p"><span class="source-update-month">2026年3月：</span>2025年第一期（1-2月）全国一张图由高级图源下放至基础图源。</p>
            <p class="source-update-p"><span class="source-update-month">2026年5月：</span>2025年第二期（3-4月）全国一张图由高级图源下放至基础图源。</p>
            <p class="source-update-p"><span class="source-update-month">2026年7月：</span>2025年第三期（5-6月）全国一张图由高级图源下放至基础图源。</p>
            <p class="source-update-p"><span class="source-update-month">2026年9月：</span>2025年第四期（7-8月）全国一张图由高级图源下放至基础图源。</p>
            <p class="source-update-p"><span class="source-update-month">2026年11月：</span>2025年第五期（9-10月）全国一张图由高级图源下放至基础图源。</p>
            <p class="source-update-p"><span class="source-update-month">2027年1月：</span>2025年第六期（11-12月）全国一张图由高级图源下放至基础图源。</p>
          </div>
        </div>
      </div>
    </div>
    <Double11Activity />
  </div>
</template>

<script>
import { rootUrl } from "@/globalConfig";
import gsap from "gsap";
import Double11Activity from "@/components/double11/Double11Activity.vue";
export default {
  name: "Home",
  components: { Double11Activity },
  props: {
    // 滚动速度（像素/帧），60fps下约合每秒60*step px
    step: {
      type: Number,
      default: 0.8
    },
    // 自动滚动间隔（ms），实际由requestAnimationFrame控制，此参数仅用于重启定时器
    autoSpeed: {
      type: Number,
      default: 16 // 约60fps
    }
  },
  data() {
    return {
      showSourceUpdateModal: false,
      titleSel:1,
      items: [
        { showImg:true,
          title:'城市规划与智慧城市',
          paragraph:[{title:'土地利用监测与规划',content:'规划部门利用时效性高的影像，分析城市扩张、土地利用变化，为新区规划、旧城改造提供直观依据。'},
            {title:'基础设施管理',content:'精确定位道路、桥梁、管网、电力设施等，用于资产清查、维护计划制定和施工进度监控。'},
            {title:'违章建筑监测',content:'通过对比不同时期的影像，快速发现和核查违规建设行为。'},
            {title:'智慧城市可视化',content:'作为城市信息模型（CIM）和各类智慧城市管理平台的基础底图，集成人口、交通、环境等数据，实现城市运行状态一图感知。'}]
        },
        {showImg:true,
          title:'农业与林业',
          paragraph:[{title:'精准农业',content:'通过分析影像中的植被指数，评估作物长势、识别病虫害区域、预估产量，指导变量施肥和灌溉，节约资源。'},
            {title:'种植面积统计',content:'快速、准确地提取农作物或经济林（如果园、橡胶林）的种植面积，为农业补贴、产量预估和保险理赔提供数据支持。'},
            {title:'林业资源调查',content:'监测森林覆盖率变化、评估森林健康状态、及时发现非法砍伐和森林火灾迹地。'}]
        },
        {showImg:true,
          title:'环境保护与气象',
          paragraph:[{title:'环境监测',content:'监测水体污染（如藻华、赤潮）、空气污染（雾霾分布）、固体废弃堆放等环境问题。'},
            {title:'生态系统研究',content:'跟踪湿地、冰川、海岸线等生态敏感区域的变化，研究全球气候变化的影响。'}]
        },
        {showImg:true,
          title:'保险与金融',
          paragraph:[{title:'保险定损',content:'在农险、财险等领域，利用灾前灾后的卫星影像对比，快速、客观地进行损失评估，防止欺诈。'},
            {title:'投资风险评估',content:'金融机构在投资大型项目（如矿山、大型工厂）前，利用卫星影像评估项目所在地的自然环境、基础设施条件等潜在风险，并及时了解各类投资/抵押物施工进度。'}]
        },
        {showImg:true,
          title:'教育与科研',
          paragraph:[{title:'互动教学',content:'作为生动的地理教材，让学生直观学习地形、地貌、城市分布等知识。'},
            {title:'科学研究',content:'支持为科研项目、研究论文提供数据来源与作证，论文等可申请使用授权。'}]
        },
        {showImg:true,
          title:'房地产',
          paragraph:[{title:'房产评估与展示',content:'在线房产平台将房源信息精确地定位在卫星影像上，让用户直观了解房产的周边环境、交通、绿化、配套设施（如学校、商场）等情况。'},
            {title:'地块信息查询',content:'潜在买家或投资者可以查看地块的实际状况、地形地貌和周边开发情况。'}]
        },
        {showImg:true,
         title:'交通运输',
          paragraph:[{title:'路网规划与设计',content:'在公路、铁路等线性工程的规划阶段，卫星影像是进行路线比选、评估征地拆迁范围的重要工具。'},
            {title:'物流与配送优化',content:'物流公司利用高清道路网络和实时交通数据（常叠加在影像底图上），规划最高效的配送路线。'},
            {title:'港口与航运管理',content:'监测港口船舶停靠情况、仓储区域布局，优化运营效率。'}]
        },
        {showImg:true,
          title:'商业决策与统计咨询',
          paragraph:[{title:'选址分析',content:'零售商利用影像分析潜在店址周边的交通便利性、竞争对手分布、社区密度和居民区规模，做出科学的选址决策。'},
            {title:'物流与配送优化',content:'物流公司利用高清道路网络和实时交通数据（常叠加在影像底图上），规划最高效的配送路线。'},
            {title:'市场分析',content:'通过分析特定区域（如工业园区、住宅区）的车辆数量、新建建筑等变化，推断经济活跃度，辅助商业决策。'}]
        }
      ],
      offset: 0,
      animFrame: null,
      paused: false,
      itemWidth: 376,
      gap: 24,

    };
  },
  methods: {
    openSourceUpdateModal() {
      this.showSourceUpdateModal = true;
      document.body.style.overflow = "hidden";
    },
    closeSourceUpdateModal() {
      this.showSourceUpdateModal = false;
      document.body.style.overflow = "";
    },
    getKey() {
      return localStorage.getItem("token");
    },
    //带权限判断的跳转
    jumpWithPermission(type, path, fromUrl) {
      //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
      //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
      let loginUserId = localStorage.getItem("userId"); //是否已登录
      let authentication = localStorage.getItem("authentication"); //0:已实名；1：未实名
      if (type == "可游客") {
        if (fromUrl) {
          window.open(
            rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
            "_self"
          );
        } else {
          window.open(rootUrl + path, "_self");
        }
      } else if (type == "仅登录") {
        //已登录
        if (loginUserId) {
          if (fromUrl) {
            window.open(
              rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
              '_self'
            );
          } else {
            window.open(rootUrl + path, '_self');
          }
        }
        //未登录
        else {
          if (fromUrl) {
            window.open(
              rootUrl + "/Login" + "?fromUrl=" + rootUrl + fromUrl,
              "_self"
            );
          } else {
            window.open(rootUrl + "/Login", "_self");
          }
        }
      } else if (type == "仅实名") {
        //已登录
        if (loginUserId) {
          //已实名
          if (authentication == "0") {
            if (fromUrl) {
              window.open(
                rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
                "_self"
              );
            } else {
              window.open(rootUrl + path, "_self");
            }
          }
          //未实名
          else {
            window.open(rootUrl + "/Authentication", "_self");
          }
        }
        //未登录
        else {
          if (fromUrl) {
            window.open(
              rootUrl + "/Login" + "?fromUrl=" + rootUrl + fromUrl,
              "_self"
            );
          } else {
            window.open(rootUrl + "/Login", "_self");
          }
        }
      }
    },
    jumpLabWithPermission(path){
      let loginUserId = localStorage.getItem("userId"); //是否已登录
      if (loginUserId) {
        window.open(rootUrl + path, '_blank')
      }else{
        window.open(rootUrl + "/Login", "_self");
      }
    },
    getItemStyle(index) {
      const isLastInGroup = (index % 8) === 7;
      return {
        width: this.itemWidth + 'px',
        marginRight: this.gap + 'px',
        flexShrink: 0,
      };
    },
    autoScroll() {
      if (this.paused) return;
      this.offset -= this.step;
      this.animFrame = requestAnimationFrame(this.autoScroll);
    },
    startAutoScroll() {
      this.paused = false;
      if (this.animFrame) cancelAnimationFrame(this.animFrame);
      this.animFrame = requestAnimationFrame(this.autoScroll);
    },
    pauseAutoScroll() {
      this.paused = true;
      if (this.animFrame) {
        cancelAnimationFrame(this.animFrame);
        this.animFrame = null;
      }
    },
    cancelAnimation() {
      if (this.animFrame) {
        cancelAnimationFrame(this.animFrame);
        this.animFrame = null;
      }
    },
  },
  mounted() {
    document.getElementById("barId").scrollIntoView({ behavior: "instant" });
    this.startAutoScroll();
  },
  beforeDestroy() {
    this.cancelAnimation();
    if (this.showSourceUpdateModal) {
      document.body.style.overflow = "";
    }
  },
  computed: {
    displayItems() {
      return [...this.items, ...this.items];
    },
    originalWidth() {
      return 8 * this.itemWidth + 7 * this.gap;
    },
    trackStyle() {
      return {
        transform: `translateX(${this.offset}px)`,
        display: 'flex',
      };
    }
  },
  watch:{
    offset(newVal) {
      if (newVal <= -this.originalWidth) {
        this.offset += this.originalWidth;
      }
      if (newVal > 0) {
        this.offset -= this.originalWidth;
      }
    }
  }
};
</script>
<style scoped>
.bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.top {
  position: relative;
  /* margin-top: 76px; */
  width: 100vw;
  height: 600px;
  background-position: center;
  background-size: cover;
  background-image: url("../assets/Home/背景.png");
}
.topText1 {
  position: absolute;
  top: 160px;
  width: 100%;
  height: 72px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 52px;
  color: #ffffff;
  line-height: 72px;
  text-align: center;
}
.topText2 {
  position: absolute;
  top: 280px;
  width: 100%;
  height: 64px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
}
.topBtn1 {
  position: absolute;
  top: 424px;
  left: calc(50% - 300px);
  width: 184px;
  height: 54px;
  background: #1890ff;
  border-radius: 8px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 54px;
  text-align: center;
  cursor: pointer;
}
.topBtn1:hover{
  background: #40A9FF;
}
.topBtn2{
  position: absolute;
  top: 424px;
  left: calc(50% - 92px);
  width: 184px;
  height: 54px;
  border-radius: 8px;
  border: 2px solid #FFFFFF;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 54px;
  text-align: center;
  cursor: pointer;
}
.topBtn2:hover{
  background: rgba(255,255,255,0.1);
}
.content1{
  position: relative;
  width: 100vw;
  height: 514px;
  background: #fff;
}
.ctn1Text1{
  position: relative;
  top: 80px;
  width: 100%;
  height: 46px;
  color: rgba(0, 0, 0, 0.85);
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 38px;
  line-height: 46px;
  text-align: center;
}
.ctn1{
  position: absolute;
  width: 1176px;
  height: 268px;
  top: 166px;
  left: calc(50% - 588px);
}
.ctn1Title{
  position: absolute;
  top: 0px;
  left: 0;
  width: 600px;
  height: 28px;
  border-bottom: 1px solid #F0F0F0;
}
.ctn1Title1{
  float: left;
  margin-right: 24px;
  width: 96px;
  height: 28px;
  border-bottom: 2px solid #1890FF;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #1890FF;
  line-height: 28px;
  text-align: center;
}
.ctn1Title1-s{
  float: left;
  margin-right: 24px;
  width: 96px;
  height: 28px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0,0,0,0.65);
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}
.ctn1Text2{
  position: absolute;
  top: 74px;
  left: 0;
  width: 700px;
  height: 33px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: #000000;
  line-height: 33px;
}
.ctn1Text3{
  position: absolute;
  top: 155px;
  width:700px;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
}
.content2{
  position: relative;
  width: 100vw;
  height: 972px;
  background: linear-gradient( 270deg, #F7FAFD 0%, #FCFDFF 100%);
}
.ctn2{
  position: absolute;
  width: 1196px;
  height: 720px;
  top: 166px;
  left: calc(50% - 588px);
}
.ctn2Block1{
  position: absolute;
  top: 0;
  left: 0;
  width: 576px;
  height: 320px;
  background: #FFFFFF;
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.5);
  border-radius: 12px;
  border: 1px solid #D9D9D9;
}
.ctn2Text1{
  position: absolute;
  top: 24px;
  left: 260px;
  width: auto;
  height: 32px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: rgba(0,0,0,0.85);
  line-height: 32px;
}
.ctn2Line1{
  position: absolute;
  top: 64px;
  left: 40px;
  width: 496px;
  height: 2px;
  border-top: 1px solid #F0F0F0;
}
.ctn2Text2{
  position: relative;
  margin-bottom: 16px;
  width: 576px;
  height: 24px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0,0,0,0.65);
  line-height: 24px;
}
.ctn2Circle{
  position: absolute;
  top: 6px;
  left: 80px;
  width: 12px;
  height: 12px;
  background: rgba(0,0,0,0.65);
  border-radius: 50%;
}
.ctn2Text3{
  position: absolute;
  left: 108px;
  width: auto;
  height: 24px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0,0,0,0.65);
  line-height: 24px;
}
.ctn2Btn1{
  position: absolute;
  left: 100px;
  bottom: 40px;
  width: 176px;
  height: 40px;
  background: #1890FF;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.ctn2Block2{
  position: absolute;
  top: 360px;
  width: 1176px;
  height: 316px;
  background: #FFFFFF;
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.5);
  border-radius: 12px;
}
.ctn2Text4{
  position: absolute;
  top: 24px;
  width: 100%;
  height: 28px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: rgba(0,0,0,0.85);
  line-height: 28px;
  text-align: center;
}
.ctn2Text5{
  position: absolute;
  top: 27px;
  left: 1044px;
  width: auto;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #1890FF;
  line-height: 22px;
  cursor: pointer;
}
.source-update-mask {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}
.source-update-dialog {
  position: relative;
  width: 100%;
  max-width: 880px;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  background: #ffffff;
  border-radius: 16px;
  padding: 36px 40px 40px;
  box-sizing: border-box;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.source-update-close {
  position: absolute;
  top: 16px;
  right: 20px;
  width: 32px;
  height: 32px;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 22px;
  line-height: 32px;
  color: rgba(0, 0, 0, 0.45);
}
.source-update-close:hover {
  color: rgba(0, 0, 0, 0.65);
}
.source-update-dialog-title {
  margin: 0 32px 24px 0;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 26px;
}
.source-update-body {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 20px;
}
.source-update-section {
  margin-bottom: 20px;
}
.source-update-section:last-child {
  margin-bottom: 0;
}
.source-update-p {
  margin: 0 0 8px;
}
.source-update-section .source-update-p:not(:first-child) {
  text-indent: 2em;
}
.source-update-section .source-update-p:last-child {
  margin-bottom: 0;
}
.source-update-month {
  font-weight: 400;
}
.content3{
  position: relative;
  width: 100vw;
  height: 698px;
  background: #FFFFFF;
  overflow: hidden;
}
</style>
<style scoped>
.carousel-container {
  margin-top: 190px;
  width: 100%;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  user-select: none;
}

.carousel-track {
  display: flex;
  will-change: transform;
}

.carousel-item {
  position: relative;
  height:428px;
  background: #F7FAFD;
  border-radius: 32px;

}
.content3Card{
  position: absolute;
  width: 376px;
  height: 428px;
  border-radius: 32px;
  cursor: pointer;
}
.cardImg{
  position: absolute;
  top: 0;
  left: 0;
  width: 376px;
  height: 188px;
}
.card3Title{
  position: absolute;
  top: 212px;
  left: 24px;
  width: auto;
  height: 32px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: rgba(0,0,0,0.85);
  line-height: 32px;
}
.card3Title-s{
  position: absolute;
  top: 24px;
  left: 24px;
  width: auto;
  height: 32px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: rgba(0,0,0,0.85);
  line-height: 32px;
}
.cardText1{
  position: relative;
  width: 376px;
  height: 24px;
}
.cardCircle{
  position: absolute;
  top: 8px;
  left: 24px;
  width: 8px;
  height: 8px;
  background: rgba(0,0,0,0.65);
  border-radius: 50%;
}
.cardText2{
  position: absolute;
  left: 40px;
  width: auto;
  height: 24px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0,0,0,0.65);
  line-height: 24px;
  text-align: left;
}
.cardText3{
  position: relative;
  margin-left: 24px;
  margin-bottom: 8px;
  width: 328px;
  height: 66px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 14px;
  color: rgba(0,0,0,0.65);
  line-height: 22px;
}
</style>
<style scoped>
.content4{
  position: relative;
  width: 100vw;
  height: 688px;
  background: linear-gradient( 90deg, #FCFDFF 0%, #F7FAFD 100%);
}
.ctn4Text1{
  position: absolute;
  top: 166px;
  width:100%;
  height: 28px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0,0,0,0.65);
  line-height: 28px;
  text-align: center;
}
.ctn4Block1{
  position: absolute;
  top: 234px;
  left: calc(50% - 588px);
  width: 576px;
  height: 374px;
  background: #FFFFFF;
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.5);
  border-radius: 12px;
}
.ctn4Text2{
  position: absolute;
  top: 24px;
  left: 260px;
  width: auto;
  height: 32px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 24px;
  color: rgba(0,0,0,0.85);
  line-height: 32px;
}
.ctn4Text3{
  position: absolute;
  top: 64px;
  left: 113px;
  width: auto;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
}
.ctn4Line{
  position: absolute;
  top: 94px;
  left: 40px;
  width: 496px;
  height: 1px;
  border-top: 1px solid #F0F0F0;
}
.ctn4Icon1{
  position: absolute;
  top: 118px;
  left: 100px;
}
.ctn4Text4{
  position: absolute;
  top: 110px;
  left: 128px;
  width: auto;
  height: 24px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0,0,0,0.65);
  line-height: 24px;
}
.ctn4Btn1{
  position: absolute;
  top: 294px;
  left: 100px;
  width: 176px;
  height: 40px;
  background: #1890FF;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
</style>
